import type { InventoryListByIdAPI } from '@openx/types/inventoryList';
import type { RowActionProps, TableColumn } from '@openx/types/tableHelpers';
import { useGetListTableColumns } from './useGetListTableColumns';
import { useInventoryListsRowActions } from './useInventoryListsRowActions';

type UseInventoryListsTableConfigProps = (searchPhrase: string) => {
  columns: TableColumn<InventoryListByIdAPI>[];
  rowActions: RowActionProps<InventoryListByIdAPI>[];
};

export const useInventoryListsTableConfig: UseInventoryListsTableConfigProps = searchPhrase => {
  const rowActions = useInventoryListsRowActions();
  const tableColumns = useGetListTableColumns(searchPhrase);

  return {
    columns: tableColumns,
    rowActions,
  };
};
